import React from "react";
import "./index.scss";

function Footerr() {
  const navigateToFacebook = () => {
    window.location.href =
      "https://www.facebook.com/profile.php?id=100064825131042&mibextid=wwXIfr&rdid=VmVHWlHIQePYbvTn&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1EHkSnrxuA%2F%3Fmibextid%3DwwXIfr#";
  };
  const navigateToInstaGram = () => {
    window.location.href =
      "https://www.instagram.com/mhiri_store_phone?igsh=OGxvaW8wazBlNmZz";
  };
  const navigateToTikTok = () => {
    window.location.href =
      "https://www.tiktok.com/@mhiri.store2?_t=ZM-8wbCIM4TLdd&_r=1";
  };
  const handleOpenMap = () => {
    const lat = 35.843548;
    const lng = 10.598889;
    const url = `https://www.google.com/maps?q=${lat},${lng}`;
    window.open(url, "_blank");
  };

  return (
    <footer className="footer">
      <div className="newsletter-container">
        <h2>Inscrivez-vous à la newsletter</h2>
        <div className="newsletter-content">
          <p>
            Recevez nos dernières offres, nouveautés et astuces directement dans
            votre boîte mail.
          </p>
          <div className="newsletter-form">
            <input type="email" placeholder="Entrez votre adresse email" />
            <button className="join-btn" type="submit">
              S’inscrire
            </button>
          </div>
        </div>
      </div>

      <div className="footer-content">
        <div className="footer-column brand-column">
          <img
            src="./../assets/logoWBG.png"
            alt="Mhiri Store"
            style={{ height: 90, width: 90 }}
          />
          <p>
            Mhiri Store Phones est votre boutique technologique moderne pour
            tous vos besoins en smartphones – performance, style et innovation à
            portée de main.
          </p>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <i
              className="bx bxl-facebook-circle"
              style={{ fontSize: 28, marginRight: 10 }}
              onClick={navigateToFacebook}
            ></i>
            <i
              className="bx bxl-instagram"
              style={{ fontSize: 28 }}
              onClick={navigateToInstaGram}
            ></i>
            <i
              className="bx bxl-tiktok"
              style={{ fontSize: 28 }}
              onClick={navigateToTikTok}
            ></i>
          </div>
        </div>

        <div className="footer-column">
          <h3>Entreprise</h3>
          <ul>
            <li>
              <a href="/about-us">À propos</a>
            </li>
            <li>
              <a href="#">Produits</a>
            </li>
            <li>
              <a href="#">Contact</a>
            </li>
            <li>
              <a href="#">Blog</a>
            </li>
            <li>
              <a href="#">Recrutement</a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Informations</h3>
          <ul>
            <li>
              <a href="#">Centre d’aide</a>
            </li>
            <li>
              <a href="#">Moyens de paiement</a>
            </li>
            <li>
              <a href="#">Retour & Remboursement</a>
            </li>
            <li>
              <a href="/policy">Politique de confidentialité</a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>Contact</h3>
          <p>Téléphone : 26219101</p>
          <p>Email : hedi.mhiri17@gmail.com</p>
          <button
            style={{
              backgroundColor: "#e6b37a",
              color: "#000",
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: 16,
            }}
            onClick={handleOpenMap}
          >
            📍 Voir l’emplacement
          </button>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Mhiri Store Phones. Tous droits réservés.</p>
        Icônes des moyens de paiement
      </div>
    </footer>
  );
}

export default Footerr;
